<h1>{{ provider.name }}</h1>

<ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link"
      routerLink="/providers/{{provider.id}}"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }">
      Details
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link"
      routerLink="/providers/{{provider.id}}/users"
      routerLinkActive="active">
      Users
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link active"
      routerLink="/providers/{{provider.id}}/reports"
      routerLinkActive="active">
      Reports
    </a>
  </li>
</ul>

<!-- === REPORTS CONFIG BODY === -->

<form [formGroup]="quicksightReportForm" class="mt-3">
  <table class="table table-striped">
    <ng-container formArrayName="reports">
      <tbody>
        @for (report of reportMapping; track report; let i = $index) {
          <tr [formGroupName]="i">
            <th class="width-250">{{ report.report_name }}</th>
            <td>
              <ui-switch
                formControlName="value"
                [disabled]="!editingMapping">
              </ui-switch>
            </td>
          </tr>
        }
      </tbody>
    </ng-container>
  </table>
</form>

@if (!editingMapping) {
  <div class="text-left">
    <button class="btn btn-primary" (click)="editMapping()">Edit</button>
  </div>
}

@if (editingMapping) {
  <div class="action-wrap text-left">
    <button type="button" class="btn btn-default" (click)="cancelEditing()">Close</button>
    <button type="button" class="btn btn-primary"
      [disabled]="!quicksightReportForm.valid"
      (click)="update()">
      Update
    </button>
  </div>
}